// Малкият приглушен чип „изтрит" до името на продукт, изтрит в организацията
// (меко — `deleted`/`productDeleted`, или физически — заварените „#31"). Стои в
// списъците, които могат да съдържат такъв продукт: „Наличности" (таблица,
// карти, тесният списък) и хедърът на складовата карта. Подсказката казва защо
// го няма в търсачките.
import { useTranslation } from "react-i18next";

export const DeletedProductChip = ({ className = "" }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <span
      title={t("inventoryPage.sd6DeletedHint")}
      className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-fill-2 px-1.5 py-px text-[11px] font-medium leading-[normal] text-muted ${className}`}
    >
      {t("inventoryPage.sd6DeletedChip")}
    </span>
  );
};
